import { Injectable, inject } from '@angular/core';
import type {
  AgencyBrandingOptionsGetListPayload,
  AgencyBrandingOptionsResponse,
} from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ReportingApiService } from './reporting-api.service';

@Injectable({ providedIn: 'root' })
export class AgencyBrandingApiService {
  private readonly reportingApiService = inject(ReportingApiService);
  private readonly basePath = '/api/agency-branding';

  getOptionsList(
    payload: AgencyBrandingOptionsGetListPayload | Record<string, unknown> | null | undefined = {},
  ): Promise<AgencyBrandingOptionsResponse> {
    return this.reportingApiService.request<AgencyBrandingOptionsResponse>(`${this.basePath}/options/get-list`, {
      method: 'POST',
      body: this.normalizePayload(payload),
    });
  }

  private normalizePayload(
    payload: AgencyBrandingOptionsGetListPayload | Record<string, unknown> | null | undefined,
  ): Record<string, unknown> {
    if (!payload || typeof payload !== 'object') {
      return {
        skip: 0,
        requireTotalCount: false,
        sort: [],
        filter: [],
      };
    }

    return Object.entries(payload).reduce<Record<string, unknown>>((result, [key, value]) => {
      if (value !== undefined) {
        result[key] = value;
      }

      return result;
    }, {});
  }
}
